document.addEventListener("turbo:load", () => {
  if (window.gtag) {
    window.gtag("event", "page_view");
  }
});
